import React from 'react';

import FileDownload from '../../view/list/templates/ActionsTemplate/FileDownload';
import PrintFile from '../../view/list/templates/ActionsTemplate/PrintFile';

function FileVersionActionsTemplate({ rowData, e }) {
  const printFileFormats = [
    // 'image/png',
    'application/pdf',
    // docTypeVal,
    // 'image/jpeg',
    // 'image/jpg',
    // 'image/gif',
    // 'image/bmp',
    // 'image/tiff',
    // 'image/webp',
    // 'image/heic',
    // 'image/heif',
    // 'text/plain',
    // 'text/csv',
  ];

  return (
    <React.Fragment>
      <div key={e.rowIndex} className="d-flex gap-3">
        <span className="p-column-title text-break">Actions</span>

        {rowData.entry_type !== 'folder' && (
          <>
            {rowData.file_type && printFileFormats.includes(rowData.file_type) && <PrintFile rowData={rowData} />}
            <FileDownload rowData={rowData} />
          </>
        )}
      </div>
    </React.Fragment>
  );
}

export default FileVersionActionsTemplate;
